import actionTypes from '@atom/actions/actionTypes';
import type { ArcgisLayerData } from '@atom/types/arcgis';

export const setArcgisLayerData = (id: string, layerData: ArcgisLayerData) => ({
  type: actionTypes.SET_ARCGIS_LAYER_DATA,
  data: { id, layerData },
});

export const removeArcgisLayerData = (id: string) => ({
  type: actionTypes.REMOVE_ARCGIS_LAYER_DATA,
  data: { id },
});
